export class MediaType {

  public static APPLICATION_OCTET_STREAM_VALUE = "application/octet-stream";
  
  public static APPLICATION_PDF = "application/pdf";
  
  public static APPLICATION_JSON = "application/json";

}